var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"occ-tooltip",class:[
      _vm.angle ? ("occ-tooltip--" + _vm.angle) : '',
      _vm.background ? ("occ-tooltip__background--" + _vm.background) : '',
      _vm.color ? ("occ-tooltip__color--" + _vm.color) : '',
      _vm.size ? ("occ-tooltip__size--" + _vm.size) : ''
    ],style:(_vm.styles),attrs:{"rounded":""}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }